import { render, staticRenderFns } from "./UserGroupUserAssignment.vue?vue&type=template&id=f7dc4f70&"
import script from "./UserGroupUserAssignment.vue?vue&type=script&lang=js&"
export * from "./UserGroupUserAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports